import ComparisonForm from "./ComparisonForm";

export default function AddComparison() {
  return <ComparisonForm />;
}
